export enum DecreeActions {
  fetchDecreeHeader = '[Calendar]: fetch decree header',
  fetchDecreeHeaderSuccess = '[Calendar]: fetch decree header success',
  fetchDecreeHeaderFailure = '[Calendar]: fetch decree header failure',

  fetchDecreeSidebar = '[Calendar]: fetch decree sidebar',
  fetchDecreeSidebarSuccess = '[Calendar]: fetch decree sidebar success',
  fetchDecreeSidebarFailure = '[Calendar]: fetch decree sidebar failure',

  fetchDecreePrimaryActions = '[Calendar]: fetch decree primary actions',
  fetchDecreePrimaryActionsSuccess = '[Calendar]: fetch decree primary actions success',
  fetchDecreePrimaryActionsFailure = '[Calendar]: fetch decree primary actions failure',

  fetchDecreeGeneral = '[Calendar]: fetch decree general',
  fetchDecreeGeneralSuccess = '[Calendar]: fetch decree general success',
  fetchDecreeGeneralFailure = '[Calendar]: fetch decree general failure',

  fetchDecreeAttachments = '[Calendar]: fetch decree attachments',
  fetchDecreeAttachmentsSuccess = '[Calendar]: fetch decree attachments success',
  fetchDecreeAttachmentsFailure = '[Calendar]: fetch decree attachments failure',

  fetchDecreeComments = '[Calendar]: fetch decree comments',
  fetchDecreeCommentsSuccess = '[Calendar]: fetch decree comments success',
  fetchDecreeCommentsFailure = '[Calendar]: fetch decree comments failure',

  fetchDecreeApprovals = '[Calendar]: fetch decree approvals',
  fetchDecreeApprovalsSuccess = '[Calendar]: fetch decree approvals success',
  fetchDecreeApprovalsFailure = '[Calendar]: fetch decree approvals failure',

  fetchDecreeInfo = '[Calendar]: fetch decree info',
  fetchDecreeInfoSuccess = '[Calendar]: fetch decree info success',
  fetchDecreeInfoFailure = '[Calendar]: fetch decree info failure',

  fetchDecreeRights = '[Calendar]: fetch decree rights',
  fetchDecreeRightsSuccess = '[Calendar]: fetch decree rights success',
  fetchDecreeRightsFailure = '[Calendar]: fetch decree rights failure',

  fetchDecreeFinancial = '[Calendar]: fetch decree financial',
  fetchDecreeFinancialSuccess = '[Calendar]: fetch decree financial success',
  fetchDecreeFinancialFailure = '[Calendar]: fetch decree financial failure',

  fetchDecreeNotes = '[Calendar]: fetch decree notes',
  fetchDecreeNotesSuccess = '[Calendar]: fetch decree notes success',
  fetchDecreeNotesFailure = '[Calendar]: fetch decree notes failure',

  fetchDecreeWebcast = '[Calendar]: fetch decree webcast',
  fetchDecreeWebcastSuccess = '[Calendar]: fetch decree webcast success',
  fetchDecreeWebcastFailure = '[Calendar]: fetch decree webcast failure',

  fetchDecreeImportedDecree = '[Calendar]: fetch decree imported decree',
  fetchDecreeImportedDecreeSuccess = '[Calendar]: fetch decree imported decree success',
  fetchDecreeImportedDecreeFailure = '[Calendar]: fetch decree imported decree failure'
}
